import React from 'react'
import ReactDOM from 'react-dom/client'
import SubpageApp from './SubpageApp'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SubpageApp />
  </React.StrictMode>,
)
